import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ClinicalContactForm from "./sections/ClinicalContactForm";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ClinicalContactForm />
      <Footer />
    </div>;
}